import React from 'react';

var example = {
    "WMTS": <span>
        介接網址：https://ntmap.nantou.gov.tw/wmts<br />
        範例：https://ntmap.nantou.gov.tw/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&Layer=(災害潛勢圖)06hr_150mm<br />
        &Style=default&Format=image/png&TileMatrixSet=EPSG:3857&TileMatrix=12&TileRow=1768&TileCol=3422</span>,
    "WMS": <span>
        介接網址：https://ntmap.nantou.gov.tw/wms<br />
        範例：https://ntmap.nantou.gov.tw/wms?&SERVICE=WMS&<br />VERSION=1.0.0&REQUEST=GetMap&<br />
        BBOX=120.64369482202913275,24.06525451933858051,120.69891877452353413,24.09601623808858051&<br />
        SRS=EPSG:4326&WIDTH=1202&HEIGHT=669&LAYERS=EMAP&STYLES=&FORMAT=image/png&DPI=96&<br />
        MAP_RESOLUTION=96&FORMAT_OPTIONS=dpi:96&TRANSPARENT=TRUE</span>,
    "I3S": <span>I3S服務網址規則：https://i3s.nlsc.gov.tw/building/i3s/SceneServer/layers/建物服務代碼</span>,
    "3DTiles": <span>3D Tiles服務網址規則：https://3dtiles.nlsc.gov.tw/building/tiles3d/建物服務代碼/tileset.json</span>
}

export default example;